export const maxInt = 2147483647;

export function isUnlimited(limit: number | undefined, limitType: API.Feature["feature"]): boolean {
    if (
        limitType === "GroupLimit" ||
        limitType === "GroupNestingLimit" ||
        limitType === "FileSizeLimit" ||
        limitType === "CommandLimit" ||
        limitType === "DeviceStateHistoryLimit"
    ) {
        // TODO: Remove this check once the backend respects limits
        return true;
    }

    return limit === maxInt;
}
